import React from 'react';
import { Skeleton, Container, Grid, Box } from '@mui/material';

const EagleSharePromoSkeletonV2 = () => (
  <Box my={3}>
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        {/* Header Section */}
        <Grid item xs={12}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexDirection={{ xs: 'column', md: 'row' }}
            gap={3}
            mb={3}
          >
            {/* Title */}
            <Skeleton variant="text" width={250} height={40} />
            {/* Button placeholder */}
            <Skeleton
              variant="rectangular"
              width={120}
              height={40}
              sx={{ borderRadius: 1, flexShrink: 0 }}
            />
          </Box>
        </Grid>

        {/* Bikes Section */}
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {/* First card */}
            <Grid item xl={3} lg={4} md={4} sm={6} xs={6}>
              <Skeleton variant="rectangular" width="100%" height={150} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="60%" height={20} />
            </Grid>

            {/* Second card */}
            <Grid item xl={3} lg={4} md={4} sm={6} xs={6}>
              <Skeleton variant="rectangular" width="100%" height={150} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="60%" height={20} />
            </Grid>

            {/* Third card (hidden on lg) */}
            <Grid
              item
              xl={3}
              lg={4}
              md={4}
              sm={6}
              xs={6}
              sx={{ display: { xs: 'none', md: 'none', lg: 'none' ,xl: 'block' } }}
            >
              <Skeleton variant="rectangular" width="100%" height={150} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="60%" height={20} />
            </Grid>
             {/* fours card (hidden on sm) */}
            <Grid
              item
              xl={3}
              lg={4}
              md={4}
              sm={6}
              xs={6}
              sx={{ display: {sm: 'none', md: 'none', lg: 'none' ,xl: 'block' } }}
            >
              <Skeleton variant="rectangular" width="100%" height={150} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="60%" height={20} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export { EagleSharePromoSkeletonV2 };
